<template>
    <div v-if="data.length" class="flex gap-y-6 flex-col container-lg py-10">
        <template v-for="(item, i) in data" :key="i">
            <!-- <template v-if="!('content' in item)">
                <div class="tabs__nav-item active">
                    {{ in18[item.translation] }}
                </div>
                <div class="py-[40px]">
                    <div v-for="(row, ri) in item.rows" :key="ri" class="flex flex-wrap large:flex-row" >
                        <div v-for="(group, gi) in row" :key="gi" class="w-full large:w-1/2">
                            <h3 class="tabs__title fw-500">
                                    {{ group.group_name }}
                            </h3>
                            <table class="tabs__table">
                                <tr v-for="(property, pi) in group.properties" :key="pi">
                                    <td>{{ property.property_title }}</td>
                                    <td class="text-dark fw-500">{{ property.selected_option_value }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </template> -->
            <template v-if="!('content' in item)"><!-- attributes -->
                <div class="tabs__nav-item active">
                    {{ in18[item.translation] }}
                </div>
                <div class="py-[40px]">
                    <div class="flex w-full gap-4">
                        <div v-if="tableContents[0]?.length" class="flex-1">
                            <template v-for="item,i in tableContents[0]" :key="i">
                                <div v-if="!item?.props" class="bg-slate-100 text-center content-center py-2">
                                    {{ item.name }}
                                </div>
                                <div v-else class="grid grid-cols-2 w-full border-b border-gray-200 py-3">
                                    <div class="content-center">{{ item.name }}</div>
                                    <div class="text-dark fw-500 content-center">{{ item.props }}</div>
                                </div>
                            </template>
                        </div>
                        <div v-if="tableContents[1]?.length && tableContents[2] > 1 " class="flex-1">
                            <template v-for="item,i in tableContents[1]" :key="i">
                                <div v-if="!item?.props" class="bg-slate-100 text-center content-center py-2">
                                    {{ item.name }}
                                </div>
                                <div v-else class="grid grid-cols-2 w-full border-b border-gray-200 py-3">
                                    <div class="content-center">{{ item.name }}</div>
                                    <div class="text-dark fw-500 content-center">{{ item.props }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
             <template v-else><!-- description -->
                <div class="tabs__nav-item active">
                    {{ in18[item.translation] }}
                </div>
                <div class="product__description revert mt-[40px]" :class="[!showReadMoreLink ? 'line-clamp-3  ' : 'mb-[40px]']" v-html="item.content"/>
                <a v-if="showReadMoreLinkButton(item)" :title="in18['read_more_label']" class="link link--primary fw-500 mb-[40px]" href="#"
                    @click.prevent="toggleReadMoreLink">
                    {{ in18['read_more_label'] }}
                </a>
               <div v-if="product.video_url" class="row p-2 mb-2">
                 <div class="col-12">
                   <div class="video-frame">
                     <iframe
                         :src="product.video_url"
                         frameborder="0"
                         allowfullscreen
                         class="w-full h-[300px] sm:h-[400px] md:h-[500px]"
                     ></iframe>

                   </div>
                 </div>
               </div>

            </template>
        </template>
    </div>
</template>
  
  
<script>
export default {
    name: 'ProductInformation',
    props: {
        product: Object,
        in18: {
            type: Object,
        },
    },
    data() {
        return {
            data: [],
            maxShortDescriptionLength: 300,
            showReadMoreLink: false
        };
    },
    mounted() {
        this.setData()
    },

    computed: {
        tableContents() {
            const screenSize = window.innerWidth
            let col1, col2
            let cols = 2

            if (screenSize < 768) {
                cols = 1
            } else if (screenSize < 1280) {
                cols = 2
            }

            if(!this.data?.length) {
                return [col1, col2, cols]
            }
            const rowsObject = this.data.find(item => 'rows' in item);

            if(!rowsObject) {
                return [col1, col2, cols]
            }

            const formattedItems = rowsObject.rows.flatMap((row) => row).flatMap((row) => {
                    // const title = [{ name: row.group_name }]
                    const props = row.properties.map((group) => {
                        return {
                            name: group.property_title,
                            props: group.selected_option_value
                        }
                    } )
                    // return [...title, ...props]
                    return props
                })

            const itemsPerCol = Math.ceil(formattedItems.length / cols)
            
            if(cols === 1) {
                col1 = formattedItems
                return [col1, col2, cols]
            }
            if(cols === 2) {
                col1 = formattedItems.slice(0, itemsPerCol)
                col2 = formattedItems.slice(itemsPerCol)
                return [col1, col2, cols]
            }
        }
    },

    methods: {
        showReadMoreLinkButton(item) {
        // Show the "Read More" link button if the short description exceeds the maximum length and is not expanded.
        return !this.showReadMoreLink && item.content.length > this.maxShortDescriptionLength;
        },  
        toggleReadMoreLink() {
            this.showReadMoreLink = !this.showReadMoreLink;
        },
        setData() {
            const { description, property_groups: properties = [] } = this.product

            if (description && description.trim() !== '') {
                const item = {
                    translation: 'page_product_description',
                    content: description
                }
                this.data.push(item)
            }

            if (properties.length > 0) {//divide property groups in rows
                const item = {
                    translation: 'page_product_technical_specification',
                    rows: [],
                }
                let currentRow = [];

                properties.forEach((element, index) => {
                    currentRow.push(element);

                    if (currentRow.length === 2 || index === properties.length - 1) {
                        // If the current row has 2 elements or it's the last element in the array
                        item.rows.push(currentRow);
                        currentRow = []; // Reset the row for the next iteration
                    }
                });

                this.data.push(item);
            }
        }
    },
};
</script>
  